module.exports = __webpack_public_path__ + "static/media/wpupvxoVf4A1.4d09dc65.jpg";